module.exports = __webpack_public_path__ + "media/9_5.dd3e74a5.wav";